export function getUserName(user) {
	return `${user.firstName} ${user.lastName}`;
}
